import { Button, Modal } from "antd";
import "./CreateFolderModal.scss";
import "./GetDesignEditLinkModal.scss";
import { env } from "../../env/env";
import { DesignDto } from "../../generated/dashboard-client";
import { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";

export interface GetDesignEditLinkModalProps {
  design: DesignDto;
  isVisible: boolean;
  onClose: () => void;
}

export function GetDesignEditLinkModal({ design, isVisible, onClose }: GetDesignEditLinkModalProps) {
  const [copyStatus, setCopyStatus] = useState('Copy');
  const [designUrl, setDesignUrl] = useState('');

  useEffect(() => {
    setDesignUrl(`${window.location.origin}${env.timberContextPath}/design?id=${design.id}`);
  }, [design.id]);

  function copy() {
    navigator.clipboard.writeText(designUrl);
    setCopyStatus('Copied!');
    setTimeout(() => {
      setCopyStatus('Copy');
    }, 3000);
  }

  const content = <>
    <header>
      <h2>Edit Link</h2>
      <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
    </header>

    <p>
      Anyone with this link can use this design as a template or copy the design. Sign-in is required.
    </p>
    <span className="link-input">{designUrl}</span>

    <footer>
      <Button
        size={"large"}
        className={"primary"}
        onClick={copy}>
        {copyStatus}
      </Button>
    </footer>
  </>

  return (
    <Modal
      className={"create-folder-modal get-design-edit-link-modal clean"}
      open={isVisible}
      onCancel={() => onClose()}
    >
      {content}
    </Modal>
  )
}
